import DesktopMonitorApprove from '@berlitz/streamline-icons/lib/regular/03-Computers-Devices-Electronics/02-Desktop-Computers/DesktopMonitorApprove'
import { TechCheckModal, withModal, WithModalProps } from '@components/Modal'
import WithUserTimeHOC, { WithUserTimeProps } from '@hocs/WithUserTime'
import { isProgramOnline } from '@utils/helpers/programs'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Container } from './style'

interface ISelfTechCheck extends WithUserTimeProps {
  Type: string
  DeliveryMode: string
  ProgramId: string
  LearningCenter: string
  EndTime: string
  endTimeOverride?: string
  Wrapper?: any
}

const SelfTechCheck: React.FC<ISelfTechCheck & WithModalProps> = (props) => {
  const {
    getDateWithUserTimezone,
    Type,
    DeliveryMode,
    EndTime,
    ProgramId,
    getUserDate,
    Wrapper,
    endTimeOverride,
    modal,
  } = props

  const end = getDateWithUserTimezone(endTimeOverride ? endTimeOverride : EndTime)

  const isOnline = isProgramOnline(Type, DeliveryMode)
  const afterEndTime = getUserDate().isAfter(end)


  if (!isOnline || afterEndTime) {
    return null
  }

  const content = (
    <Container {...props}>
      <div
        className="link"
        onClick={() =>
          modal.toggleModal(
            true,
            <TechCheckModal.Content
              onClose={() => modal.toggleModal(false)}
              pid={ProgramId}
            />
          )
        }
      >
        <DesktopMonitorApprove />{' '}
        <span className="underline">
          <FormattedMessage id="Self tech check" />
        </span>
      </div>
    </Container>
  )

  if (Wrapper) {
    return <Wrapper>{content}</Wrapper>
  }

  return content
}

export default WithUserTimeHOC(withModal(SelfTechCheck))
